export const scatterData = [
  { Temperature: 23.4055054362, Weather: 0 },
  { Temperature: 29.5967695127, Weather: 0 },
  { Temperature: 29.6653345388, Weather: 0 },
  { Temperature: 31.3190934544, Weather: 0 },
  { Temperature: 31.4138761388, Weather: 0 },
  { Temperature: 35.6056097326, Weather: 0 },
  { Temperature: 39.01261053, Weather: 0 },
  { Temperature: 41.7086471099, Weather: 0 },
  { Temperature: 43.2232442267, Weather: 0 },
  { Temperature: 43.4674973221, Weather: 0 },
  { Temperature: 43.6532069482, Weather: 0 },
  { Temperature: 45.8068351785, Weather: 0 },
  { Temperature: 46.1848351823, Weather: 0 },
  { Temperature: 46.1890748248, Weather: 0 },
  { Temperature: 46.2433057692, Weather: 0 },
  { Temperature: 46.6432266148, Weather: 0 },
  { Temperature: 46.8649180301, Weather: 0 },
  { Temperature: 48.6767110156, Weather: 0 },
  { Temperature: 49.0854737711, Weather: 0 },
  { Temperature: 49.2552923711, Weather: 0 },
  { Temperature: 49.6042976031, Weather: 0 },
  { Temperature: 50.4625552314, Weather: 0 },
  { Temperature: 50.4797059187, Weather: 0 },
  { Temperature: 50.6648900915, Weather: 0 },
  { Temperature: 50.8771021841, Weather: 0 },
  { Temperature: 52.1611600626, Weather: 0 },
  { Temperature: 53.2600343339, Weather: 0 },
  { Temperature: 54.3349633008, Weather: 0 },
  { Temperature: 55.0839624268, Weather: 0 },
  { Temperature: 55.2429643001, Weather: 0 },
  { Temperature: 56.1134077957, Weather: 0 },
  { Temperature: 56.9511960505, Weather: 0 },
  { Temperature: 57.3527957607, Weather: 0 },
  { Temperature: 57.7101173807, Weather: 0 },
  { Temperature: 58.4245628157, Weather: 0 },
  { Temperature: 60.0036588655, Weather: 0 },
  { Temperature: 62.7837923027, Weather: 0 },
  { Temperature: 62.9566269644, Weather: 1 },
  { Temperature: 64.6767801057, Weather: 0 },
  { Temperature: 65.0466273303, Weather: 1 },
  { Temperature: 65.844870564, Weather: 0 },
  { Temperature: 67.3118466598, Weather: 0 },
  { Temperature: 67.4459509036, Weather: 1 },
  { Temperature: 70.0514794089, Weather: 1 },
  { Temperature: 71.2829833937, Weather: 1 },
  { Temperature: 71.6867139953, Weather: 1 },
  { Temperature: 72.1745218842, Weather: 1 },
  { Temperature: 72.594334468, Weather: 1 },
  { Temperature: 73.0785466586, Weather: 1 },
  { Temperature: 73.6369466955, Weather: 1 },
  { Temperature: 73.8532447473, Weather: 1 },
  { Temperature: 74.0905040732, Weather: 1 },
  { Temperature: 74.1077684404, Weather: 1 },
  { Temperature: 74.7649033549, Weather: 1 },
  { Temperature: 75.5364149126, Weather: 1 },
  { Temperature: 75.8268821014, Weather: 1 },
  { Temperature: 77.0826950682, Weather: 1 },
  { Temperature: 77.6282462378, Weather: 1 },
  { Temperature: 78.1166012785, Weather: 1 },
  { Temperature: 78.346711784, Weather: 1 },
  { Temperature: 78.9049608073, Weather: 1 },
  { Temperature: 78.9255336303, Weather: 1 },
  { Temperature: 79.6061322094, Weather: 1 },
  { Temperature: 79.8660865244, Weather: 1 },
  { Temperature: 80.0000683303, Weather: 1 },
  { Temperature: 80.0631767568, Weather: 1 },
  { Temperature: 80.290775751, Weather: 1 },
  { Temperature: 80.7890855337, Weather: 1 },
  { Temperature: 81.795993164, Weather: 1 },
  { Temperature: 82.5931117566, Weather: 1 },
  { Temperature: 83.5130004475, Weather: 1 },
  { Temperature: 83.5201699201, Weather: 1 },
  { Temperature: 83.7734082441, Weather: 1 },
  { Temperature: 83.796468005, Weather: 1 },
  { Temperature: 83.8601783118, Weather: 1 },
  { Temperature: 88.2250085365, Weather: 1 },
  { Temperature: 89.5174370387, Weather: 1 },
  { Temperature: 91.4818956588, Weather: 1 },
  { Temperature: 95.6195675222, Weather: 1 },
  { Temperature: 96.0454560897, Weather: 1 },
];

export const sigmoidCurve = [
  { x: 20, y: 0.0 },
  { x: 21, y: 0.0 },
  { x: 22, y: 0.0 },
  { x: 23, y: 0.0 },
  { x: 24, y: 0.0 },
  { x: 25, y: 0.0 },
  { x: 26, y: 0.0 },
  { x: 27, y: 0.0 },
  { x: 28, y: 0.0 },
  { x: 29, y: 0.0 },
  { x: 30, y: 0.0 },
  { x: 31, y: 0.0 },
  { x: 32, y: 0.0 },
  { x: 33, y: 0.0 },
  { x: 34, y: 0.0 },
  { x: 35, y: 0.0 },
  { x: 36, y: 0.0 },
  { x: 37, y: 0.0 },
  { x: 38, y: 0.0 },
  { x: 39, y: 0.0 },
  { x: 40, y: 0.0 },
  { x: 41, y: 0.00000001 },
  { x: 42, y: 0.00000002 },
  { x: 43, y: 0.00000006 },
  { x: 44, y: 0.00000013 },
  { x: 45, y: 0.0000003 },
  { x: 46, y: 0.0000007 },
  { x: 47, y: 0.00000163 },
  { x: 48, y: 0.00000378 },
  { x: 49, y: 0.00000877 },
  { x: 50, y: 0.00002036 },
  { x: 51, y: 0.00004727 },
  { x: 52, y: 0.00010974 },
  { x: 53, y: 0.00025473 },
  { x: 54, y: 0.00059115 },
  { x: 55, y: 0.00137129 },
  { x: 56, y: 0.00317769 },
  { x: 57, y: 0.00734615 },
  { x: 58, y: 0.0168901 },
  { x: 59, y: 0.03835425 },
  { x: 60, y: 0.08474404 },
  { x: 61, y: 0.17692001 },
  { x: 62, y: 0.33288996 },
  { x: 63, y: 0.53670127 },
  { x: 64, y: 0.72894613 },
  { x: 65, y: 0.86193971 },
  { x: 66, y: 0.93545724 },
  { x: 67, y: 0.97113737 },
  { x: 68, y: 0.98735956 },
  { x: 69, y: 0.99451559 },
  { x: 70, y: 0.99763015 },
  { x: 71, y: 0.9989778 },
  { x: 72, y: 0.99955942 },
  { x: 73, y: 0.99981017 },
  { x: 74, y: 0.99991822 },
  { x: 75, y: 0.99996477 },
  { x: 76, y: 0.99998482 },
  { x: 77, y: 0.99999346 },
  { x: 78, y: 0.99999718 },
  { x: 79, y: 0.99999879 },
  { x: 80, y: 0.99999948 },
  { x: 81, y: 0.99999977 },
  { x: 82, y: 0.9999999 },
  { x: 83, y: 0.99999996 },
  { x: 84, y: 0.99999998 },
  { x: 85, y: 0.99999999 },
  { x: 86, y: 1.0 },
  { x: 87, y: 1.0 },
  { x: 88, y: 1.0 },
  { x: 89, y: 1.0 },
  { x: 90, y: 1.0 },
  { x: 91, y: 1.0 },
  { x: 92, y: 1.0 },
  { x: 93, y: 1.0 },
  { x: 94, y: 1.0 },
  { x: 95, y: 1.0 },
  { x: 96, y: 1.0 },
  { x: 97, y: 1.0 },
  { x: 98, y: 1.0 },
  { x: 99, y: 1.0 },
  { x: 100, y: 1.0 },
];

export const logLossY0 = [
  { Probability: 0.01, LogLoss: 0.0100503359 },
  { Probability: 0.02, LogLoss: 0.0202027073 },
  { Probability: 0.03, LogLoss: 0.0304592075 },
  { Probability: 0.04, LogLoss: 0.0408219945 },
  { Probability: 0.05, LogLoss: 0.0512932944 },
  { Probability: 0.06, LogLoss: 0.0618754037 },
  { Probability: 0.07, LogLoss: 0.0725706928 },
  { Probability: 0.08, LogLoss: 0.0833816089 },
  { Probability: 0.09, LogLoss: 0.0943106795 },
  { Probability: 0.1, LogLoss: 0.1053605157 },
  { Probability: 0.11, LogLoss: 0.1165338163 },
  { Probability: 0.12, LogLoss: 0.1278333715 },
  { Probability: 0.13, LogLoss: 0.1392620673 },
  { Probability: 0.14, LogLoss: 0.1508228897 },
  { Probability: 0.15, LogLoss: 0.1625189295 },
  { Probability: 0.16, LogLoss: 0.1743533871 },
  { Probability: 0.17, LogLoss: 0.1863295782 },
  { Probability: 0.18, LogLoss: 0.1984509387 },
  { Probability: 0.19, LogLoss: 0.2107210313 },
  { Probability: 0.2, LogLoss: 0.2231435513 },
  { Probability: 0.21, LogLoss: 0.2357223335 },
  { Probability: 0.22, LogLoss: 0.2484613593 },
  { Probability: 0.23, LogLoss: 0.2613647641 },
  { Probability: 0.24, LogLoss: 0.2744368457 },
  { Probability: 0.25, LogLoss: 0.2876820725 },
  { Probability: 0.26, LogLoss: 0.3011050928 },
  { Probability: 0.27, LogLoss: 0.3147107448 },
  { Probability: 0.28, LogLoss: 0.328504067 },
  { Probability: 0.29, LogLoss: 0.3424903089 },
  { Probability: 0.3, LogLoss: 0.3566749439 },
  { Probability: 0.31, LogLoss: 0.3710636814 },
  { Probability: 0.32, LogLoss: 0.3856624808 },
  { Probability: 0.33, LogLoss: 0.4004775666 },
  { Probability: 0.34, LogLoss: 0.415515444 },
  { Probability: 0.35, LogLoss: 0.4307829161 },
  { Probability: 0.36, LogLoss: 0.4462871026 },
  { Probability: 0.37, LogLoss: 0.4620354596 },
  { Probability: 0.38, LogLoss: 0.4780358009 },
  { Probability: 0.39, LogLoss: 0.4942963218 },
  { Probability: 0.4, LogLoss: 0.5108256238 },
  { Probability: 0.41, LogLoss: 0.5276327421 },
  { Probability: 0.42, LogLoss: 0.5447271754 },
  { Probability: 0.43, LogLoss: 0.5621189182 },
  { Probability: 0.44, LogLoss: 0.5798184953 },
  { Probability: 0.45, LogLoss: 0.5978370008 },
  { Probability: 0.46, LogLoss: 0.6161861394 },
  { Probability: 0.47, LogLoss: 0.6348782724 },
  { Probability: 0.48, LogLoss: 0.6539264674 },
  { Probability: 0.49, LogLoss: 0.6733445533 },
  { Probability: 0.5, LogLoss: 0.6931471806 },
  { Probability: 0.51, LogLoss: 0.7133498879 },
  { Probability: 0.52, LogLoss: 0.7339691751 },
  { Probability: 0.53, LogLoss: 0.7550225843 },
  { Probability: 0.54, LogLoss: 0.7765287895 },
  { Probability: 0.55, LogLoss: 0.7985076962 },
  { Probability: 0.56, LogLoss: 0.8209805521 },
  { Probability: 0.57, LogLoss: 0.8439700703 },
  { Probability: 0.58, LogLoss: 0.8675005677 },
  { Probability: 0.59, LogLoss: 0.8915981193 },
  { Probability: 0.6, LogLoss: 0.9162907319 },
  { Probability: 0.61, LogLoss: 0.9416085399 },
  { Probability: 0.62, LogLoss: 0.9675840263 },
  { Probability: 0.63, LogLoss: 0.9942522733 },
  { Probability: 0.64, LogLoss: 1.0216512475 },
  { Probability: 0.65, LogLoss: 1.0498221245 },
  { Probability: 0.66, LogLoss: 1.0788096614 },
  { Probability: 0.67, LogLoss: 1.1086626245 },
  { Probability: 0.68, LogLoss: 1.1394342832 },
  { Probability: 0.69, LogLoss: 1.1711829815 },
  { Probability: 0.7, LogLoss: 1.2039728043 },
  { Probability: 0.71, LogLoss: 1.237874356 },
  { Probability: 0.72, LogLoss: 1.2729656758 },
  { Probability: 0.73, LogLoss: 1.30933332 },
  { Probability: 0.74, LogLoss: 1.347073648 },
  { Probability: 0.75, LogLoss: 1.3862943611 },
  { Probability: 0.76, LogLoss: 1.4271163556 },
  { Probability: 0.77, LogLoss: 1.4696759701 },
  { Probability: 0.78, LogLoss: 1.5141277326 },
  { Probability: 0.79, LogLoss: 1.5606477483 },
  { Probability: 0.8, LogLoss: 1.6094379124 },
  { Probability: 0.81, LogLoss: 1.6607312068 },
  { Probability: 0.82, LogLoss: 1.7147984281 },
  { Probability: 0.83, LogLoss: 1.7719568419 },
  { Probability: 0.84, LogLoss: 1.8325814637 },
  { Probability: 0.85, LogLoss: 1.8971199849 },
  { Probability: 0.86, LogLoss: 1.9661128564 },
  { Probability: 0.87, LogLoss: 2.0402208285 },
  { Probability: 0.88, LogLoss: 2.1202635362 },
  { Probability: 0.89, LogLoss: 2.2072749132 },
  { Probability: 0.9, LogLoss: 2.302585093 },
  { Probability: 0.91, LogLoss: 2.4079456087 },
  { Probability: 0.92, LogLoss: 2.5257286443 },
  { Probability: 0.93, LogLoss: 2.6592600369 },
  { Probability: 0.94, LogLoss: 2.8134107168 },
  { Probability: 0.95, LogLoss: 2.9957322736 },
  { Probability: 0.96, LogLoss: 3.2188758249 },
  { Probability: 0.97, LogLoss: 3.5065578973 },
  { Probability: 0.98, LogLoss: 3.9120230054 },
  { Probability: 0.99, LogLoss: 4.605170186 },
];

export const logLossY1 = [
  { Probability: 0.01, LogLoss: 4.605170186 },
  { Probability: 0.02, LogLoss: 3.9120230054 },
  { Probability: 0.03, LogLoss: 3.5065578973 },
  { Probability: 0.04, LogLoss: 3.2188758249 },
  { Probability: 0.05, LogLoss: 2.9957322736 },
  { Probability: 0.06, LogLoss: 2.8134107168 },
  { Probability: 0.07, LogLoss: 2.6592600369 },
  { Probability: 0.08, LogLoss: 2.5257286443 },
  { Probability: 0.09, LogLoss: 2.4079456087 },
  { Probability: 0.1, LogLoss: 2.302585093 },
  { Probability: 0.11, LogLoss: 2.2072749132 },
  { Probability: 0.12, LogLoss: 2.1202635362 },
  { Probability: 0.13, LogLoss: 2.0402208285 },
  { Probability: 0.14, LogLoss: 1.9661128564 },
  { Probability: 0.15, LogLoss: 1.8971199849 },
  { Probability: 0.16, LogLoss: 1.8325814637 },
  { Probability: 0.17, LogLoss: 1.7719568419 },
  { Probability: 0.18, LogLoss: 1.7147984281 },
  { Probability: 0.19, LogLoss: 1.6607312068 },
  { Probability: 0.2, LogLoss: 1.6094379124 },
  { Probability: 0.21, LogLoss: 1.5606477483 },
  { Probability: 0.22, LogLoss: 1.5141277326 },
  { Probability: 0.23, LogLoss: 1.4696759701 },
  { Probability: 0.24, LogLoss: 1.4271163556 },
  { Probability: 0.25, LogLoss: 1.3862943611 },
  { Probability: 0.26, LogLoss: 1.347073648 },
  { Probability: 0.27, LogLoss: 1.30933332 },
  { Probability: 0.28, LogLoss: 1.2729656758 },
  { Probability: 0.29, LogLoss: 1.237874356 },
  { Probability: 0.3, LogLoss: 1.2039728043 },
  { Probability: 0.31, LogLoss: 1.1711829815 },
  { Probability: 0.32, LogLoss: 1.1394342832 },
  { Probability: 0.33, LogLoss: 1.1086626245 },
  { Probability: 0.34, LogLoss: 1.0788096614 },
  { Probability: 0.35, LogLoss: 1.0498221245 },
  { Probability: 0.36, LogLoss: 1.0216512475 },
  { Probability: 0.37, LogLoss: 0.9942522733 },
  { Probability: 0.38, LogLoss: 0.9675840263 },
  { Probability: 0.39, LogLoss: 0.9416085399 },
  { Probability: 0.4, LogLoss: 0.9162907319 },
  { Probability: 0.41, LogLoss: 0.8915981193 },
  { Probability: 0.42, LogLoss: 0.8675005677 },
  { Probability: 0.43, LogLoss: 0.8439700703 },
  { Probability: 0.44, LogLoss: 0.8209805521 },
  { Probability: 0.45, LogLoss: 0.7985076962 },
  { Probability: 0.46, LogLoss: 0.7765287895 },
  { Probability: 0.47, LogLoss: 0.7550225843 },
  { Probability: 0.48, LogLoss: 0.7339691751 },
  { Probability: 0.49, LogLoss: 0.7133498879 },
  { Probability: 0.5, LogLoss: 0.6931471806 },
  { Probability: 0.51, LogLoss: 0.6733445533 },
  { Probability: 0.52, LogLoss: 0.6539264674 },
  { Probability: 0.53, LogLoss: 0.6348782724 },
  { Probability: 0.54, LogLoss: 0.6161861394 },
  { Probability: 0.55, LogLoss: 0.5978370008 },
  { Probability: 0.56, LogLoss: 0.5798184953 },
  { Probability: 0.57, LogLoss: 0.5621189182 },
  { Probability: 0.58, LogLoss: 0.5447271754 },
  { Probability: 0.59, LogLoss: 0.5276327421 },
  { Probability: 0.6, LogLoss: 0.5108256238 },
  { Probability: 0.61, LogLoss: 0.4942963218 },
  { Probability: 0.62, LogLoss: 0.4780358009 },
  { Probability: 0.63, LogLoss: 0.4620354596 },
  { Probability: 0.64, LogLoss: 0.4462871026 },
  { Probability: 0.65, LogLoss: 0.4307829161 },
  { Probability: 0.66, LogLoss: 0.415515444 },
  { Probability: 0.67, LogLoss: 0.4004775666 },
  { Probability: 0.68, LogLoss: 0.3856624808 },
  { Probability: 0.69, LogLoss: 0.3710636814 },
  { Probability: 0.7, LogLoss: 0.3566749439 },
  { Probability: 0.71, LogLoss: 0.3424903089 },
  { Probability: 0.72, LogLoss: 0.328504067 },
  { Probability: 0.73, LogLoss: 0.3147107448 },
  { Probability: 0.74, LogLoss: 0.3011050928 },
  { Probability: 0.75, LogLoss: 0.2876820725 },
  { Probability: 0.76, LogLoss: 0.2744368457 },
  { Probability: 0.77, LogLoss: 0.2613647641 },
  { Probability: 0.78, LogLoss: 0.2484613593 },
  { Probability: 0.79, LogLoss: 0.2357223335 },
  { Probability: 0.8, LogLoss: 0.2231435513 },
  { Probability: 0.81, LogLoss: 0.2107210313 },
  { Probability: 0.82, LogLoss: 0.1984509387 },
  { Probability: 0.83, LogLoss: 0.1863295782 },
  { Probability: 0.84, LogLoss: 0.1743533871 },
  { Probability: 0.85, LogLoss: 0.1625189295 },
  { Probability: 0.86, LogLoss: 0.1508228897 },
  { Probability: 0.87, LogLoss: 0.1392620673 },
  { Probability: 0.88, LogLoss: 0.1278333715 },
  { Probability: 0.89, LogLoss: 0.1165338163 },
  { Probability: 0.9, LogLoss: 0.1053605157 },
  { Probability: 0.91, LogLoss: 0.0943106795 },
  { Probability: 0.92, LogLoss: 0.0833816089 },
  { Probability: 0.93, LogLoss: 0.0725706928 },
  { Probability: 0.94, LogLoss: 0.0618754037 },
  { Probability: 0.95, LogLoss: 0.0512932944 },
  { Probability: 0.96, LogLoss: 0.0408219945 },
  { Probability: 0.97, LogLoss: 0.0304592075 },
  { Probability: 0.98, LogLoss: 0.0202027073 },
  { Probability: 0.99, LogLoss: 0.0100503359 },
];
